import React, { ReactElement, useCallback, useState } from 'react'
import { debounce } from 'lodash'

type Props = {
    label: string
    value: number | string
    configKey: string
    onChange: (configKey: string, newValue: number | string) => void
    children?: unknown
    minValueAllowed?: number
    maxValueAllowed?: number
    height?: string
    className?: string
}

export default function NumericField(props: Props): ReactElement {
    const [value, setValue] = useState(props.value)
    const handleOnChange = (newValue: number): void => {
        if (typeof props.value === 'string') {
            setValue(newValue.toString())
            onChange(newValue.toString(), props)
        } else {
            setValue(newValue)
            onChange(newValue, props)
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onChange = useCallback(
        debounce((x, p) => p.onChange(p.configKey, x), 1000),
        []
    )

    return (
        <div className="input-config" style={{ margin: '0 0 6px 0' }}>
            <label>{props.label}</label>
            <div className="input-field">
                <input
                    className={props.className}
                    type="number"
                    placeholder="auto"
                    min={props?.minValueAllowed}
                    max={props?.maxValueAllowed}
                    value={value}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(+e.target.value)}
                    style={props.height ? { height: props.height, boxShadow: 'none' } : { boxShadow: 'none' }}
                />
                {props.children}
            </div>
        </div>
    )
}
